// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'hand-over-paper';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='m.563 1.663 1.125 1.419v3.35c-.03 1.266 1.437 2.4 2.811 3.564m-.576-4.477L5.25 6.878a.914.914 0 0 0 1.309-1.276L4.495 3.498V2.4A4.714 4.714 0 0 0 3.762.563' />
    <path d='M4.5 6.104v9.084a1.125 1.125 0 0 0 1.125 1.124h5.063m6.75.025-1.125-1.42v-3.349c.026-1.094-1.066-2.09-2.25-3.09' />
    <path d='M7.313 2.813h5.625a1.125 1.125 0 0 1 1.124 1.124v8.528l-1.312-1.343a.914.914 0 0 0-1.309 1.276l2.066 2.106V15.6c.113.656.363 1.282.734 1.835' />
  </g>
);

export const viewBox = '0 0 18 18';
